import Vue from "vue";
import Router from "vue-router";
import main from "@/views/main";
import Technology from "@/views/technology/technology";
import Product from "@/views/product/product";
import Application from "@/views/application/application";
import News from "@/views/news/news";
import AboutUs from "@/views/aboutUs/aboutUs";
import Download from "@/views/download/download";
import DownloadZxh from "@/views/download/downloadZxh";
import Privacy from "@/views/privacy/privacy";
import Agreement from "@/views/agreement/agreement";
import PrivacyFxh from "@/views/privacy/privacyFxh";
import AgreementFxh from "@/views/agreement/agreementFxh";
import Documentation from "@/views/documentation/documentation";

Vue.use(Router);

// 获取原型对象上的push函数
const originalPush = Router.prototype.push;
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export const constantRoutes = [
  {
    path: "/",
    name: "Main",
    component: main,
  },
  {
    path: "/technology",
    name: "Technology",
    component: Technology,
  },
  {
    path: "/product",
    name: "Product",
    component: Product,
  },
  {
    path: "/documentation",
    name: "Documentation",
    component: Documentation,
  },
  {
    path: "/application",
    name: "Application",
    component: Application,
  },
  {
    path: "/news",
    name: "News",
    component: News,
  },
  {
    path: "/aboutUs",
    name: "AboutUs",
    component: AboutUs,
  },
  {
    path: "/download",
    name: "Download",
    meta: { singlePage: true },
    component: Download,
  },
  {
    path: "/downloadZxh",
    name: "DownloadZxh",
    meta: { singlePage: true },
    component: DownloadZxh,
  },
  {
    path: "/download/:param",
    name: "Download",
    meta: { singlePage: true },
    component: Download,
  },
  {
    path: "/privacy",
    name: "Privacy",
    meta: { singlePage: true },
    component: Privacy,
  },
  {
    path: "/agreement",
    name: "Agreement",
    meta: { singlePage: true },
    component: Agreement,
  },
  {
    path: "/privacyFxh",
    name: "PrivacyFxh",
    meta: { singlePage: true },
    component: PrivacyFxh,
  },
  {
    path: "/agreementFxh",
    name: "AgreementFxh",
    meta: { singlePage: true },
    component: AgreementFxh,
  },
];

export default new Router({
  mode: "history", // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes,
});



// WEBPACK FOOTER //
// ./src/router/index.js